<template>
    <div class="ma-0" id="by_state_and_region">
        <div class="custom-table-design">
            <el-table
                    :data="paginatedData"
                    :fit="true"
                    height="300"
                    class="my-2 width-100-p data-table"
                    stripe
                    scrollbar-always-on: false
                >
                <el-table-column
                    :label="'Region'"
                    :prop="'state'"
                    :width="$vuetify.display.width <= 2560 ? 180 : ''"
                    sortable
                    />
                    <el-table-column
                    :label="'Country'"
                    :prop="'country'"
                    :width="$vuetify.display.width <= 2560 ? 180 : ''"
                    sortable
                    />
                    <el-table-column
                    :label="'Customer'"
                    :prop="'client'"
                    :width="$vuetify.display.width <= 2560 ? 180 : ''"
                    sortable
                    />
                    <el-table-column
                    :label="'AFEC'"
                    :prop="'afec'"
                    :width="$vuetify.display.width <= 2560 ? 180 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.afec == null
                            ? ""
                            : Number(scope.row.afec).toLocaleString()
                        }}
                    </template>
                    </el-table-column>

                    <el-table-column
                    :label="'MPG'"
                    :prop="'mpg'"
                    :width="$vuetify.display.width <= 2560 ? 180 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.mpg == null
                            ? ""
                            : Number(scope.row.mpg).toLocaleString()
                        }}
                    </template>
                    </el-table-column>

                    <el-table-column
                    :label="'No. Existing Chargers'"
                    :prop="'no_existing_chargers'"
                    :width="$vuetify.display.width <= 2560 ? 200 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.no_existing_chargers == null
                            ? ""
                            : Number(scope.row.no_existing_chargers).toLocaleString()
                        }}
                    </template>
                    </el-table-column>
                    <el-table-column
                    :label="'No. Utilized Chargers'"
                    :prop="'no_utilized_chargers'"
                    :width="$vuetify.display.width <= 2560 ? 200 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.no_utilized_chargers == null
                            ? ""
                            : Number(scope.row.no_utilized_chargers).toLocaleString()
                        }}
                    </template>
                    </el-table-column>
                    <el-table-column
                    :label="'Energy Delivered (MWh)'"
                    :prop="'energy_delivered'"
                    :width="$vuetify.display.width <= 2560 ? 220 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.energy_delivered == null
                            ? ""
                            : Number(scope.row.energy_delivered).toLocaleString()
                        }}
                    </template>
                    </el-table-column>

                    <el-table-column
                    :label="'Energy Consumed (MWh)'"
                    :prop="'energy_consumed'"
                    :width="$vuetify.display.width <= 2560 ? 220 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.energy_consumed == null
                            ? ""
                            : Number(scope.row.energy_consumed).toLocaleString()
                        }}
                    </template>
                    </el-table-column>

                    <el-table-column
                    :label="'Emission Intensity (tCO2-e/MWh)'"
                    :prop="'emission_factor_electricity'"
                    :width="$vuetify.display.width <= 2560 ? 280 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.emission_factor_electricity == null
                            ? ""
                            : Number(scope.row.emission_factor_electricity).toLocaleString()
                        }}
                    </template>
                    </el-table-column>

                    <el-table-column
                    :label="'Project (tCO2-e)'"
                    :prop="'project_tco2'"
                    :width="$vuetify.display.width <= 2560 ? 180 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.project_tco2 == null
                            ? ""
                            : Number(scope.row.project_tco2).toLocaleString()
                        }}
                    </template>
                    </el-table-column>

                    <el-table-column
                    :label="'Baseline (tCO2-e)'"
                    :prop="'baseline_tco2'"
                    :width="$vuetify.display.width <= 2560 ? 180 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.baseline_tco2 == null
                            ? ""
                            : Number(scope.row.baseline_tco2).toLocaleString()
                        }}
                    </template>
                    </el-table-column>

                    <el-table-column
                    :label="'Abatement (tCO2-e)'"
                    :prop="'abatement_tco2'"
                    :width="$vuetify.display.width <= 2560 ? 200 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.abatement_tco2 == null
                            ? ""
                            : Number(scope.row.abatement_tco2).toLocaleString()
                        }}
                    </template>
                    </el-table-column>

                    <el-table-column
                    :label="'Abatement per MWh'"
                    :prop="'abatement_per_mwh'"
                    :width="$vuetify.display.width <= 2560 ? 200 : ''"
                    sortable
                    >
                    <template #default="scope">
                        {{
                        scope.row.abatement_per_mwh == null
                            ? ""
                            : Number(scope.row.abatement_per_mwh).toLocaleString()
                        }}
                    </template>
                    </el-table-column>


            </el-table>
        </div>

            <!-- page count and pagination -->
            <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
                <el-row class="row-bg" justify="space-between">
                    <el-col
                    :span="5"
                    class="d-flex justify-content-start align-items-center"
                    >
                    <el-select
                        v-model="perPageCount"
                        placeholder="Select"
                        size="small"
                        style="width: 70px"
                    >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
                    </el-select>
                    </el-col>
                    <el-col
                    :span="8"
                    class="d-flex align-items-center justify-content-center"
                    >
                    <el-pagination
                        small
                        background
                        layout="prev, pager, next"
                        :total="total_items"
                        v-model:page-size="page_size"
                        v-model:current-page="current_page"
                        @current-change="changePage"
                        class="my-4"
                    />
                    </el-col>
                    <el-col :span="5" class="d-flex justify-content-end align-items-center">
                    <span class="text-white">
                        {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                        current_page * perPageCount > total_items
                            ? total_items.toLocaleString()
                            : (current_page * perPageCount).toLocaleString()
                        }}
                        of {{ total_items.toLocaleString() }}
                    </span>
                    </el-col>
                </el-row>
            </div>
            <!-- page count and pagination -->

            <!-- page count and pagination -->
            <div class="custom-pagination" v-if="$vuetify.display.width < 700">
                <el-row class="row-bg" justify="space-between">
                    <el-col
                    :span="24"
                    class="d-flex align-items-center justify-content-center"
                    >
                    <el-pagination
                        small
                        background
                        layout="prev, pager, next"
                        :total="total_items"
                        v-model:page-size="page_size"
                        v-model:current-page="current_page"
                        @current-change="changePage"
                        class="my-4"
                    />
                    </el-col>
                    <el-col
                    :span="10"
                    class="d-flex justify-content-end align-items-center"
                    >
                    <el-select
                        v-model="perPageCount"
                        placeholder="Select"
                        size="small"
                        style="width: 70px"
                    >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
                    </el-select>
                    </el-col>
                    <el-col :span="10" class="d-flex justify-content-start align-items-center">
                    <span class="text-white">
                        {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                        current_page * perPageCount > total_items
                            ? total_items.toLocaleString()
                            : (current_page * perPageCount).toLocaleString()
                        }}
                        of {{ total_items.toLocaleString() }}
                    </span>
                    </el-col>
                </el-row>
            </div>
            <!-- page count and pagination -->


    </div>
</template>

<script>
import auditorReportTableFromPropMixin from "./auditorReportTableFromPropMixin";

export default {
    mixins: [auditorReportTableFromPropMixin],
};
</script>

